import React from 'react'
import moment from 'moment'
import { UserManagementBuyerStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  InputSearch,
  Paginate,
  Section,
  SelectBox,
  Table,
  Input,
  Text,
  Breadcrumbs,
} from '../../components'
import { usermanageController } from '../../apiService'
import { ICONS } from '../../themes'
import { ROUTE_PATH, STRING, toastFail } from '../../helpers'
import { isEmpty } from 'lodash'
import { toast } from 'react-toastify'
import { store } from 'store'
import { connect } from 'react-redux'
import { getUser } from '../../store/user/actions'
import { logout } from '../../store/actions'
import {
  dateMonDayYearTime,
  formatNumberWithComma,
} from '../../helpers/functions/format'
import ReactTooltip from 'react-tooltip'
import { filterSearchInput, filterSearchOptions } from '../../store/actions'
import { pageUserManagementController } from '../../middleware'
import NumberFormat from 'react-number-format'
export class UserManagementBuyerContainers extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)
    this.state = {
      options: [
        { value: '0', label: 'All' },
        { value: '3', label: 'Admin' },
        { value: '9', label: 'Approver' },
        { value: '11', label: 'Observer' },
        { value: '8', label: 'Purchaser' },
        { value: '7', label: 'Risk Management' },
        { value: '10', label: 'TEC' },
        { value: '4', label: 'User' },
      ],
      isSortBy: [
        { name: 'employee_id', value: undefined },
        { name: 'name', value: undefined },
        { name: 'last_update', value: undefined },
      ],
      modals: [
        { name: 'history', isOpen: false },
        {
          name: 'delete',
          isOpen: false,
          Idlist: '',
          Fullname: '',
        },
      ],
      search: '',
      data: {
        role_id: 0,
        keyword: '',
        page: 1,
      },
      BuyerListLoading: false,
      BuyerList: [],
      searchPage: 1,
      activePage: 1,
      searchValue: '',
      historyDetail: [],
      checkRole: '',
    }
    this.optionsValue = 0
    this.listdele = ''
    this.searchinput = ''
    this.isSuperAdmin = false
    this.renderUserManagement = this.renderUserManagement.bind(this)
  }

  toggleSort = evt => {
    var value
    this.state.isSortBy.find(column => {
      if (column.name === evt && column.value == undefined) {
        value = 'desc'
      } else if (column.name === evt && column.value == 'asc') {
        value = 'desc'
      } else if (column.name === evt && column.value == 'desc') {
        value = 'asc'
      }
      return value
    })
    if (this._isMounted) {
      this.setState(
        {
          data: {
            ...this.state.data,
            sort_by: value,
            sort_name: evt,
          },
        },
        () => {
          this.setState(prevState => ({
            ...prevState,
            isSortBy: prevState.isSortBy.map(column => ({
              ...column,
              value:
                column.name === evt
                  ? column.value !== undefined
                    ? column.value === 'asc'
                      ? 'desc'
                      : 'asc'
                    : 'desc'
                  : undefined,
            })),
          }))
          this.setState({ BuyerListLoading: true })
          return usermanageController()
            .searchBuyerList(this.state.data)
            .then(res =>
              this.setState({
                BuyerList: res,
                BuyerListLoading: false,
              })
            )
            .finally(() => this.setState({ BuyerListLoading: false }))
        }
      )
    }
  }
  componentDidMount() {
    this._isMounted = true
    if (this.props.enterSearchInputFilter) {
      this._fetchsearchUsermanage(
        this.props.searchInputFilter,
        this.props.searchOptionFilter
      )
    } else if (this.props.selectedOptions) {
      this._fetchsearchUsermanage(
        this.props.searchInputFilter,
        this.props.searchOptionFilter
      )
    } else {
      this._fetchUsermanage()
    }
    const roles = pageUserManagementController().asset()
    this.setState({ checkRole: roles })
  }

  _fetchUsermanage() {
    if (this._isMounted) {
      this.setState({ BuyerListLoading: true })
    }
    return usermanageController()
      .BuyerList({ page: 1 })
      .then(res => {
        if (this._isMounted) {
          this.setState({
            BuyerList: res,
            BuyerListLoading: false,
          })
        }
        this.checkAdminRemoveMyself()
      })
      .finally(() => {
        if (this._isMounted) {
          this.setState({ BuyerListLoading: false })
        }
      })
  }

  async _fetchdeleteUsermanage(id) {
    let { activePage } = this.state
    if (this._isMounted) {
      this.setState({ BuyerListLoading: true })
    }
    const res = await usermanageController().deleteBuyerList(id)
    store.dispatch(getUser('getuser'))

    if (res) {
      await this._fetchUsermanage()
      activePage = 1
      this.checkAdminRemoveMyself()
      this.setState({ activePage })
    } else {
      if (this._isMounted) {
        this.setState({ BuyerListLoading: false })
      }
    }
  }

  filterRolerByType = role => {
    const ADMIN = 3
    const USER = 4
    const RISK_MANAGEMENT = 7
    const PURCHASER = 8
    const APPROVER = 9
    const TEC = 10
    const OBSERVER = 11
    const ALL = 0
    switch (parseInt(role)) {
      case ALL:
        return []
      case ADMIN:
        return ['2', '3']
      case RISK_MANAGEMENT:
        return [RISK_MANAGEMENT.toString()]
      case USER:
        return [USER.toString()]
      case PURCHASER:
        return [PURCHASER.toString()]
      case APPROVER:
        return [APPROVER.toString()]
      case TEC:
        return [TEC.toString()]
      case OBSERVER:
        return [OBSERVER.toString()]
      default:
        return []
    }
  }

  _fetchsearchUsermanage(value, role) {
    if (this._isMounted) {
      return this.setState(
        {
          data: {
            ...this.state.data,
            role_id: this.filterRolerByType(role.toString()),
            keyword: value,
            page: 1,
          },
        },
        () => {
          this.setState({ BuyerListLoading: true })
          return usermanageController()
            .searchBuyerList(this.state.data)
            .then(res => {
              this.setState({
                BuyerList: res,
                BuyerListLoading: false,
                activePage: res.page ? res.page : 1,
              })
            })
            .finally(() => this.setState({ BuyerListLoading: false }))
        }
      )
    }
  }

  _fetchsearchUsermanagePage(value) {
    if (this._isMounted) {
      this.setState(
        {
          BuyerListLoading: true,
          data: {
            ...this.state.data,
            role_id: this.filterRolerByType(this.props.searchOptionFilter),
            page: value,
          },
        },
        () => {
          return usermanageController()
            .searchBuyerList(this.state.data)
            .then(res => {
              this.setState({
                BuyerList: res,
                BuyerListLoading: false,
              })
            })
            .finally(() => this.setState({ BuyerListLoading: false }))
        }
      )
    }
  }

  filterSortByValue = evt => {
    return this.state.isSortBy
      .filter(columns => columns.name === evt)
      .map(column => column.value)[0]
  }

  // onClickHistory = async id => {
  //   const res = await usermanageController().getHistory(id)
  //   if (res) {
  //     if (this._isMounted) {
  //       this.setState({ historyDetail: res }, this.toggleModal('history'))
  //     }
  //   } else {
  //     toastFail('error')
  //   }
  // }

  _searchTagAdd = e => {
    const value = e.target.value
    store.dispatch(filterSearchInput(value))
    if (e.keyCode == 13) {
      const searchTrim = value.trim()
      store.dispatch(filterSearchInput(searchTrim, true))
      // this.setState(
      //   { search: value.trim() },
      //   this._fetchsearchUsermanage(value.trim(), this.optionsValue)
      // )
      this._fetchsearchUsermanage(
        this.props.searchInputFilter,
        this.props.searchOptionFilter
      )
    }
  }

  toggleModal = (evt, id, name) => {
    if (this._isMounted) {
      this.setState(prevState => ({
        ...prevState,
        modals: prevState.modals.map(modal => ({
          ...modal,
          isOpen: modal.name === evt ? !modal.isOpen : false,
          Idlist: id,
          Fullname: name,
        })),
      }))
    }
  }

  changePage = e => {
    this._fetchsearchUsermanagePage(e)
    if (this._isMounted) {
      return this.setState({ activePage: e })
    }
  }

  deleteList = () => {
    // store.dispatch(getUser('getuser'))
    this._fetchdeleteUsermanage(this.listdele)
    toast('User was Deleted', {
      position: 'top-center',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined,
      type: 'success',
    })
    this.toggleModal('delete')
    document.body.classList.remove('modal-open')
  }

  checkAdminRemoveMyself = () => {
    const idDelete = parseInt(this.listdele)
    const { user } = store.getState()
    if (user && user.id) {
      if (idDelete === user.id) {
        store.dispatch(logout())
      } else {
        store.dispatch(getUser('getuser'))
      }
    }
  }

  handleUserInput = e => {
    const { name, value } = e.target
    if (this._isMounted) {
      return this.setState({ [name]: value }, () => {})
    }
  }

  linkEdit = id => {
    this.props.history.push('/user-edit-form-buyer:' + id)
  }

  cleardata = () => {
    // this.setState({ search: '' })
    store.dispatch(filterSearchInput(''))
    this._fetchsearchUsermanage('', this.props.searchOptionFilter)
  }

  renderStatus = status => {
    switch (status) {
      case 0:
        return {
          className: 'inactive-status',
          statusName: 'Inactive',
        }
      case 1:
        return {
          className: 'active-status',
          statusName: 'Active',
        }
      case 2:
        return {
          className: 'wait-active-status',
          statusName: 'Awaiting Activate',
        }
      default:
        return {
          className: 'inactive-status',
          statusName: 'Inactive',
        }
    }
  }

  renderHistoryDetail = (actionType, detail) => {
    switch (actionType) {
      case 'Update Information And Status':
        return (
          <React.Fragment>
            Description :
            <Section className="detail-groups">
              <label>Full Name: {detail.full_name} </label>
              <label>Email: {detail.email}</label>
              <label>Phone: {detail.phone}</label>
              <label>
                Role:{' '}
                {detail.roles.map((e, i) => {
                  return e + (i !== detail.roles.length - 1 ? ' | ' : '')
                })}
              </label>
              <label>
                Employee Reference ID:{' '}
                {detail.emp_ref_id ? detail.emp_ref_id : ' -'}
              </label>
              <label>
                User Status :
                {detail.status == 1 ? 'Enable User ' : 'Disable User'}
              </label>
            </Section>
          </React.Fragment>
        )
      case 'Create User':
        return (
          <React.Fragment>
            Description :
            <Section className="detail-groups">
              <label>Full Name: {detail.full_name}</label>

              <label>Email: {detail.email}</label>
              <label>Phone: {detail.phone}</label>
              <label>
                Role:{' '}
                {detail.roles.map((e, i) => {
                  return e + (i !== detail.roles.length - 1 ? ' | ' : '')
                })}
              </label>
              <label>
                Employee Reference ID:
                {detail.emp_ref_id ? detail.emp_ref_id : ' -'}
              </label>
            </Section>
          </React.Fragment>
        )
      case 'Update Status':
        return `User Status : ${
          detail.status == 1 ? ' Enable User ' : ' Disable User'
        }`
      case 'User Activate':
        return `Email : ${detail.email}`
      case 'Send Activation Email':
        return `Email : ${detail.email}`
      default:
        break
    }
  }

  renderRole = role => {
    const SYSTEMADMIN = 'System Admin'
    const ADMIN = 'Admin'
    const USER = 'User'
    const RISK = 'Risk Management'
    switch (role) {
      case 1:
        return ADMIN
      case 2:
        return SYSTEMADMIN
      case 3:
        return ADMIN
      case 7:
        return RISK
      default:
        return USER
    }
  }
  // renderUserManagement
  renderUserManagement = () => {
    const {
      options,
      modals,
      BuyerList,
      activePage,
      search,
      historyDetail,
    } = this.state
    const listUser = BuyerList.records
    let limitLicense = this.props.user || {}
    const pageTitle = () => {
      const funcLimitLicense = () => {
        const handlerClick = e => {
          return this.props.history.push(ROUTE_PATH.USER_DETAIL_FORM_BUYER.LINK)
        }
        if (limitLicense.remain_license === 0) {
          if (this.state.checkRole) {
            return (
              <Button disabled={true} className="page-button">
                Create User
              </Button>
            )
          }
        } else {
          if (this.state.checkRole) {
            return (
              <Button className="page-button" onClick={handlerClick}>
                Create User
              </Button>
            )
          }
        }
      }
      return (
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_user_management"
                src={ICONS['icon-user-white.svg']}
                alt="page icon"
              />
            </Section>
            <Section className="title-and-breadcrumb">
              <Section id="page_title_user_management" className="title">
                {STRING.USER_MANAGEMENT}
              </Section>
              <Breadcrumbs props={this.props} />
            </Section>
          </Section>
          <Section className="page-button">{funcLimitLicense()}</Section>
        </Section>
      )
    }
    const pageContent = () => {
      const funcActiveStatusFilter = () => {
        if (options) {
          const value = options.find(
            option => option.value === this.props.searchOptionFilter
          )
          return value
        } else {
          return ''
        }
      }
      const valueActiveStatusFilter = funcActiveStatusFilter()
      const funcKeyDownfilterSearchInput = e => {
        return this._searchTagAdd(e)
      }
      const funconChangefilterSearchInput = e => {
        this._searchTagAdd(e)
        return this.handleUserInput(e)
      }
      const funcOnClickSearchClear = e => {
        return this.cleardata()
      }
      const funcOnChangeSelectBox = e => {
        this.optionsValue = e.value
        if (this.props.searchOptionFilter) {
          this._fetchsearchUsermanage(this.props.searchInputFilter, e.value)
        } else {
          this._fetchsearchUsermanage(this.props.searchInputFilter, e.value)
        }
        return store.dispatch(filterSearchOptions(e.value, true))
      }
      const funcOnClickNameHeader = e => {
        return this.toggleSort('name')
      }
      const funcOnClickEmployeeId = e => {
        return this.toggleSort('employee_id')
      }
      const funcOnclickLastUpdate = e => {
        return this.toggleSort('last_update')
      }
      const funcRenderListUser = listUser => {
        const funcRenderEmployeeId = e => {
          if (e.emp_ref_id.trim() === '') {
            return '-'
          } else {
            return e.emp_ref_id
          }
        }
        const funcRenderRole = e => {
          if (e.roles) {
            return e.roles.map((j, i) => {
              if (i !== e.roles.length - 1) {
                return j.name + ` | `
              } else {
                return j.name + ''
              }
            })
          }
        }
        const renderIsSuperAdmin = e => {
          try {
            return (this.isSuperAdmin = e.roles.map(rs => {
              return rs.id === 2
            }))
          } catch (error) {
            console.log(error)
          }
        }
        const renderActionsIsSuperAdmin = e => {
          if (this.isSuperAdmin && this.isSuperAdmin[0] != true) {
            return (
              <Section>
                {this.state.checkRole && (
                  <Button
                    className="link"
                    onClick={() => {
                      this.linkEdit(e.id)
                    }}
                  >
                    <Image
                      className="edit-icon"
                      src={ICONS['icon-edit.svg']}
                      alt="Edit"
                      tootipValue={`Edit`}
                      useTootipFor="Edit"
                      useTootip={true}
                    />
                  </Button>
                )}
                {this.state.checkRole && (
                  <Button
                    className="link"
                    onClick={() => {
                      this.toggleModal('delete', e.id, e.full_name),
                        (this.listdele = e.id)
                      document.body.classList.add('modal-open')
                    }}
                  >
                    <Image
                      className="delete-icon"
                      src={ICONS['icon-trash.svg']}
                      alt="Delete"
                      tootipValue={`Delete`}
                      useTootipFor="Delete"
                      useTootip={true}
                    />
                  </Button>
                )}
              </Section>
            )
          } else {
            return null
          }
        }
        if (listUser) {
          return listUser.map((e, index) => {
            return (
              <Table.TR key={e.id}>
                <Table.TD className="name">
                  <Text
                    tootipValue={e.full_name}
                    useTootipFor="full-name"
                    useTootip={true}
                  >
                    {e.full_name}
                  </Text>
                </Table.TD>
                <Table.TD className="email">
                  <Text
                    tootipValue={e.email}
                    useTootipFor="email"
                    useTootip={true}
                  >
                    {e.email}
                  </Text>
                </Table.TD>
                <Table.TD className="employee-id">
                  <div>{funcRenderEmployeeId(e)}</div>
                </Table.TD>
                <Table.TD className="status">
                  <p className={this.renderStatus(e.status).className}>
                    {this.renderStatus(e.status).statusName}
                  </p>
                </Table.TD>
                <Table.TD className="role">
                  <React.Fragment>
                    <div
                      data-for={index + 'name'}
                      data-tip
                      className="role-flex"
                    >
                      <Text useEllipsis={true}>
                        {e.roles &&
                          e.roles.map((itemR, r) => {
                            return r !== e.roles.length - 1
                              ? itemR.name + ' | '
                              : itemR.name
                          })}
                      </Text>
                    </div>
                    <ReactTooltip
                      id={index + 'name'}
                      place="bottom"
                      effect="solid"
                      className="background-white"
                    >
                      <div className="role-flex">
                        {e.roles &&
                          e.roles.map((itemR, r) => {
                            return r !== e.roles.length - 1
                              ? itemR.name + ' | '
                              : itemR.name
                          })}
                      </div>
                    </ReactTooltip>
                  </React.Fragment>
                </Table.TD>
                <Table.TD className="last-update">
                  <div>{dateMonDayYearTime(e.updated_at)}</div>
                </Table.TD>
                <div>{renderIsSuperAdmin(e)}</div>
                <Table.TD className="actions">
                  {renderActionsIsSuperAdmin(e)}
                </Table.TD>
              </Table.TR>
            )
          })
        }
      }
      const renderListUserIsEmpty = listUser => {
        if (isEmpty(listUser)) {
          return (
            <Table.TR>
              <Table.TD>
                <Section className="no-result-found">
                  <Image src={ICONS['icon-ssr.png']} className="no-result" />
                  <p>No result found</p>
                </Section>
              </Table.TD>
            </Table.TR>
          )
        }
      }
      const funcShowing = (listUser, BuyerList) => {
        if (isEmpty(listUser)) {
          return '0'
        } else if (BuyerList.offset === 0) {
          return '1'
        } else {
          return BuyerList.offset + 1
        }
      }
      const funcShowingTo = BuyerList => {
        const offset = BuyerList.offset + BuyerList.limit
        if (offset > BuyerList.total_record) {
          return BuyerList.total_record
        } else {
          return offset
        }
      }
      const funcTotalItemsCount = BuyerList => {
        if (BuyerList.total_record === undefined) {
          return 0
        } else {
          return BuyerList.total_record
        }
      }
      const handlerOnChangeItems = e => {
        return this.changePage(e)
      }
      const funcOnChangePaginateMoveto = e => {
        if (this._isMounted) {
          return this.setState({
            searchPage: parseInt(e.target.value),
          })
        }
      }
      const funcisAllowedPaginate = values => {
        const { value, floatValue } = values
        if (value == 0 && value !== '') {
          return false
        }
        if (typeof floatValue === 'undefined' || typeof value === 'undefined') {
          return true
        }
        if (value.charAt(0) === '0') {
          if (value.charAt(1) && value.charAt(1) != '.') {
            return false
          }
        }
        if (this.props.maximum) {
          return floatValue <= this.props.maximum
        } else {
          return true
        }
      }
      const handleOnClickGo = e => {
        return this.changePage(this.state.searchPage)
      }
      return (
        <Section className="main-content">
          <Section className="content-body">
            <Section className="table-filter">
              <InputSearch
                className="input-search"
                id="filter_search_input"
                placeholder="Employee ID, Name, Email"
                onKeyDown={funcKeyDownfilterSearchInput}
                name="searchValue"
                onChange={funconChangefilterSearchInput}
                onClickSearchClear={funcOnClickSearchClear}
                value={this.props.searchInputFilter}
                clear={'true'}
              />
              <SelectBox
                onChange={funcOnChangeSelectBox}
                id="active_status_filter"
                className="table-filter all-status"
                options={options}
                placeholder="All"
                isSearchable={false}
                isClearable={false}
                value={valueActiveStatusFilter}
              />
            </Section>
            <Section className="table-wrapper">
              <Table className="user split-row-color">
                {/* Header Row */}
                <Table.THEAD>
                  <Table.TR className="header">
                    <Table.TH
                      className="name"
                      id="name_header"
                      isSortable={true}
                      sortBy={this.filterSortByValue('name')}
                      onClick={funcOnClickNameHeader}
                    >
                      NAME
                    </Table.TH>
                    <Table.TH className="email" id="email_header">
                      EMAIL
                    </Table.TH>
                    <Table.TH
                      className="employee-id"
                      id="employee_id_header"
                      isSortable={true}
                      sortBy={this.filterSortByValue('employee_id')}
                      onClick={funcOnClickEmployeeId}
                    >
                      EMPLOYEE ID
                    </Table.TH>
                    <Table.TH className="status" id="status_header">
                      STATUS
                    </Table.TH>
                    <Table.TH className="role" id="role_header">
                      ROLE
                    </Table.TH>
                    <Table.TH
                      className="last-update"
                      id="last_update_header"
                      isSortable={true}
                      sortBy={this.filterSortByValue('last_update')}
                      onClick={funcOnclickLastUpdate}
                    >
                      LAST UPDATE
                    </Table.TH>
                    <Table.TH className="actions" id="actions_header">
                      ACTIONS
                    </Table.TH>
                  </Table.TR>
                </Table.THEAD>
                {/* Content Row */}
                <Table.TBODY>
                  {/* funcRenderListUser */}
                  {funcRenderListUser(listUser)}
                  {renderListUserIsEmpty(listUser)}
                </Table.TBODY>
              </Table>
            </Section>
          </Section>
          <Section className="content-footer">
            <Section className="showing-item">
              {`Showing ${formatNumberWithComma(
                funcShowing(listUser, BuyerList)
              )} to ${formatNumberWithComma(
                funcShowingTo(BuyerList)
              )} of ${formatNumberWithComma(BuyerList.total_record)} entries`}
            </Section>
            <Section className="paginate-wrapper">
              <Paginate
                activePage={activePage}
                itemsCountPerPage={BuyerList.limit}
                totalItemsCount={funcTotalItemsCount(BuyerList)}
                onChange={handlerOnChangeItems}
              />
              <Section className="moveto-wrapper">
                <NumberFormat
                  label="Page"
                  isHorizontal
                  className="paginate-moveto"
                  defaultValue="1"
                  maxLength="4"
                  customInput={Input}
                  decimalSeparator={false}
                  allowNegative={false}
                  allowLeadingZeros={false}
                  onChange={funcOnChangePaginateMoveto}
                  isAllowed={funcisAllowedPaginate}
                />
                <Button
                  disabled={
                    parseInt(this.state.searchPage) <=
                    parseInt(BuyerList.total_page)
                      ? false
                      : true
                  }
                  onClick={handleOnClickGo}
                >
                  go
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>
      )
    }
    const modalDelete = () => {
      return (
        <Modal
          id="delete_id"
          className="theme-blue"
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'delete'
              })
              .map(obj => obj.isOpen)[0]
          }
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>
          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete? <br />
              {modals[0].FullName}
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray"
              onClick={() => {
                this.toggleModal('delete'),
                  document.body.classList.remove('modal-open')
              }}
            >
              Cancel
            </Button>
            <Button
              id="close_modal_history_id"
              className="theme-green"
              onClick={() => {
                this.deleteList()
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    const modalHistoryLog = () => {
      return (
        <Modal
          id="history_id"
          className="user-management buyer history-user-management theme-blue"
          // isOpen={isHistoryModalOpen}
          isOpen={
            modals
              .filter(modal => {
                return modal.name === 'history'
              })
              .map(obj => obj.isOpen)[0]
          }
        >
          <Modal.Header>History Log</Modal.Header>
          <Modal.Body>
            <Section className="table-header-freeze-wrapper">
              <Table className="history header-freeze">
                <Table.TBODY>
                  <Table.TR>
                    <Table.TH className="action">ACTIONS</Table.TH>
                    <Table.TH className="detail">DETAIL</Table.TH>
                    <Table.TH className="action-by">ACTION BY</Table.TH>
                    <Table.TH className="create-date">DATE</Table.TH>
                  </Table.TR>
                </Table.TBODY>
              </Table>
              <Table className="history split-row-color">
                <Table.TBODY>
                  {!!historyDetail &&
                    historyDetail.map((e, i) => {
                      return (
                        <Table.TR key={i}>
                          <Table.TD className="action">
                            {e.action_type_string}
                          </Table.TD>

                          <Table.TD className="detail">
                            {this.renderHistoryDetail(
                              e.action_type_string,
                              e.buyer_management_response
                            )}
                          </Table.TD>
                          <Table.TD className="action-by">
                            {e.action_by}
                          </Table.TD>
                          <Table.TD className="create-date">
                            {dateMonDayYearTime(e.created_at)}
                          </Table.TD>
                        </Table.TR>
                      )
                    })}
                </Table.TBODY>
              </Table>
            </Section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              id="close_modal_history_id"
              className="theme-border-gray close"
              onClick={() => this.toggleModal()}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )
    }
    return (
      <React.Fragment>
        <UserManagementBuyerStyled>
          {pageTitle()}
          {pageContent()}
        </UserManagementBuyerStyled>
        {modalDelete()}
        {modalHistoryLog()}
      </React.Fragment>
    )
  }
  componentWillUnmount() {
    this._isMounted = false
  }
  render = () => this.renderUserManagement()
}

const mapStateToProps = state => {
  const { searchInputFilter, enterSearchInputFilter } = state.searchInput
  const { searchOptionFilter, selectedOptions } = state.searchSelectOption
  return {
    role: state.role,
    user: state.user,
    searchInputFilter,
    searchOptionFilter,
    enterSearchInputFilter,
    selectedOptions,
  }
}

export const UserManagementBuyerContainer = connect(mapStateToProps)(
  UserManagementBuyerContainers
)
